module.exports = __webpack_public_path__ + "static/media/app-discover.59b2d12a.jpeg";